import React, {Component} from 'react';
import {Router, Route, Link, Switch} from 'react-router-dom';
import CookieBanner from 'react-cookie-banner';
import Analytics from 'react-router-ga';
import history from './history';
import './App.css';
import Navigation from './navigation/Navigation';
import Footer from './footer/Footer';
import Home from './pages/home/Home';
import SpeakersPage from './pages/speakers/SpeakersPage';
import TalksPage from "./pages/talks/TalksPage";
import Registration from "./pages/registration/RegistrationPage";
import {GettingAroundPage, HotelsPage, InformationPage, VenuePage} from "./pages/information/InformationPage";
import {AboutPage} from "./pages/information/About";
import {showSpeakers, showCFP, showAgenda, showRegistration, showRatings} from './config';
import {CodeOfConduct, CookieConsentPage, PrivacyNoticePage} from "./pages/information/coc/CodeOfConduct";
import {TheCrewPage} from "./pages/information/crew/TheCrewPage";
import {ImpressionsPage} from "./pages/information/impressions/ImpressionsPage";
import ScrollToTop from "./components/helpers/ScrollToTop";
import Sponsors from "./pages/sponsors/SponsorsPage";
import {gaId, tawkIoToken} from './config';
import AgendaPage from "./pages/agenda/AgendaPage";
import TawkIO from "./components/TawkIO";
import ConfRatingPage from "./pages/rating/ConfRatingPage";
import {CFPPage} from "./pages/information/cfp/CFP";

class App extends Component {


    render() {
        const cookieMessage = (<span>
        Cookie policy: Yes, we use them to track your visit. Nothing personal though! <Link
            to="/cookies">Read  more</Link>
    </span>);

        return (
            <div>
                <Router history={history}>
                    <Analytics id={gaId} debug>
                        <ScrollToTop>
                            <TawkIO token={tawkIoToken}/>
                            <div className="App">
                                <Navigation/>
                                <div>
                                  <Switch>
                                    <Route path="/" exact component={Home}/>
                                    {showRegistration && <Route path="/registration/:voucher?" strict={false} component={Registration}/>}
                                    {showAgenda && <Route path="/agenda" component={AgendaPage}/>}
                                    {showSpeakers && <Route path="/speakers" component={SpeakersPage}/>}
                                    {showSpeakers && <Route path="/talks" component={TalksPage}/>}
                                    {showCFP && <Route path="/cfp" component={CFPPage}/>}
                                    <Route path="/information" component={InformationPage}/>
                                    <Route path="/venue" component={VenuePage}/>
                                    <Route path="/hotels" component={HotelsPage}/>
                                    <Route path="/getting-around" component={GettingAroundPage}/>
                                    <Route path="/impressions" component={ImpressionsPage}/>
                                    <Route path="/code-of-conduct" component={CodeOfConduct}/>
                                    <Route path="/privacy" component={PrivacyNoticePage}/>
                                    <Route path="/cookies" component={CookieConsentPage}/>
                                    <Route path="/about" component={AboutPage}/>
                                    <Route path="/crew" component={TheCrewPage}/>
                                    <Route path="/sponsors" component={Sponsors}/>
                                    {showRatings && <Route path="/rating" component={ConfRatingPage}/>}
                                    <Route path='*' exact={true} component={Home}/>
                                  </Switch>
                                    <CookieBanner
                                        message={cookieMessage}
                                        onAccept={() => {
                                        }}
                                        cookie="user-has-accepted-cookies-2020"
                                        dismissOnScrollThreshold={200}
                                        styles={{banner: {position: 'absolute', bottom: 0}, button: {right: 100}}}/>
                                </div>
                            </div>
                        </ScrollToTop>
                        <Footer/>
                    </Analytics>
                </Router>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js